/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BodyUploadOrgLogo,
  HTTPValidationError,
  OrgBrandingOut,
  OrgIn,
  OrgLogoOut,
  OrgOut,
  OrgSecurityIn,
  OrgSecurityOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getCurrentOrgResponse200 = {
  data: OrgOut
  status: 200
}

export type getCurrentOrgResponseSuccess = (getCurrentOrgResponse200) & {
  headers: Headers;
};
;

export type getCurrentOrgResponse = (getCurrentOrgResponseSuccess)

export const getGetCurrentOrgUrl = () => {




  return `/api/orgs/current`
}

/**
 * @summary Get Current Org
 */
export const getCurrentOrg = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getCurrentOrgResponse> => {

  return apiFetch<getCurrentOrgResponse>(getGetCurrentOrgUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCurrentOrgQueryKey = () => {
    return [
    `/api/orgs/current`
    ] as const;
    }


export const getGetCurrentOrgQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentOrg>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentOrg>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentOrgQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentOrg>>> = ({ signal }) => getCurrentOrg({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentOrg>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentOrgQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentOrg>>>
export type GetCurrentOrgQueryError = unknown


export function useGetCurrentOrg<TData = Awaited<ReturnType<typeof getCurrentOrg>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentOrg>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentOrg>>,
          TError,
          Awaited<ReturnType<typeof getCurrentOrg>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentOrg<TData = Awaited<ReturnType<typeof getCurrentOrg>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentOrg>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentOrg>>,
          TError,
          Awaited<ReturnType<typeof getCurrentOrg>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentOrg<TData = Awaited<ReturnType<typeof getCurrentOrg>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentOrg>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Current Org
 */

export function useGetCurrentOrg<TData = Awaited<ReturnType<typeof getCurrentOrg>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentOrg>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentOrgQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type updateCurrentOrgResponse200 = {
  data: OrgOut
  status: 200
}

export type updateCurrentOrgResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateCurrentOrgResponseSuccess = (updateCurrentOrgResponse200) & {
  headers: Headers;
};
export type updateCurrentOrgResponseError = (updateCurrentOrgResponse422) & {
  headers: Headers;
};

export type updateCurrentOrgResponse = (updateCurrentOrgResponseSuccess | updateCurrentOrgResponseError)

export const getUpdateCurrentOrgUrl = () => {




  return `/api/orgs/current`
}

/**
 * @summary Update Current Org
 */
export const updateCurrentOrg = async (orgIn: OrgIn, options?: Parameters<typeof apiFetch>[1]): Promise<updateCurrentOrgResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<updateCurrentOrgResponse>(getUpdateCurrentOrgUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(orgIn)
  }
);}





export const getUpdateCurrentOrgMutationKey = () => ['updateCurrentOrg'] as const;

export const getUpdateCurrentOrgMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCurrentOrg>>, TError,UpdateCurrentOrgMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCurrentOrg>>, TError,UpdateCurrentOrgMutationVariables, TContext> => {

const mutationKey = getUpdateCurrentOrgMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCurrentOrg>>, UpdateCurrentOrgMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateCurrentOrg(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCurrentOrgMutationResult = NonNullable<Awaited<ReturnType<typeof updateCurrentOrg>>>
    export type UpdateCurrentOrgMutationBody = OrgIn
    export type UpdateCurrentOrgMutationError = HTTPValidationError
    export type UpdateCurrentOrgMutationVariables = {data: OrgIn}

    /**
 * @summary Update Current Org
 */
export const useUpdateCurrentOrg = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCurrentOrg>>, TError,UpdateCurrentOrgMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCurrentOrg>>,
        TError,
        UpdateCurrentOrgMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateCurrentOrgMutationOptions(options), queryClient);
    }
    export type getOrgSecurityResponse200 = {
  data: OrgSecurityOut
  status: 200
}

export type getOrgSecurityResponseSuccess = (getOrgSecurityResponse200) & {
  headers: Headers;
};
;

export type getOrgSecurityResponse = (getOrgSecurityResponseSuccess)

export const getGetOrgSecurityUrl = () => {




  return `/api/orgs/current/security`
}

/**
 * @summary Get Org Security
 */
export const getOrgSecurity = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getOrgSecurityResponse> => {

  return apiFetch<getOrgSecurityResponse>(getGetOrgSecurityUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrgSecurityQueryKey = () => {
    return [
    `/api/orgs/current/security`
    ] as const;
    }


export const getGetOrgSecurityQueryOptions = <TData = Awaited<ReturnType<typeof getOrgSecurity>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgSecurity>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgSecurityQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgSecurity>>> = ({ signal }) => getOrgSecurity({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgSecurity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrgSecurityQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgSecurity>>>
export type GetOrgSecurityQueryError = unknown


export function useGetOrgSecurity<TData = Awaited<ReturnType<typeof getOrgSecurity>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgSecurity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgSecurity>>,
          TError,
          Awaited<ReturnType<typeof getOrgSecurity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgSecurity<TData = Awaited<ReturnType<typeof getOrgSecurity>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgSecurity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgSecurity>>,
          TError,
          Awaited<ReturnType<typeof getOrgSecurity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgSecurity<TData = Awaited<ReturnType<typeof getOrgSecurity>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgSecurity>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Org Security
 */

export function useGetOrgSecurity<TData = Awaited<ReturnType<typeof getOrgSecurity>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgSecurity>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrgSecurityQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type setOrgSecurityResponse200 = {
  data: OrgSecurityOut
  status: 200
}

export type setOrgSecurityResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type setOrgSecurityResponseSuccess = (setOrgSecurityResponse200) & {
  headers: Headers;
};
export type setOrgSecurityResponseError = (setOrgSecurityResponse422) & {
  headers: Headers;
};

export type setOrgSecurityResponse = (setOrgSecurityResponseSuccess | setOrgSecurityResponseError)

export const getSetOrgSecurityUrl = () => {




  return `/api/orgs/current/security`
}

/**
 * @summary Set Org Security
 */
export const setOrgSecurity = async (orgSecurityIn: OrgSecurityIn, options?: Parameters<typeof apiFetch>[1]): Promise<setOrgSecurityResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<setOrgSecurityResponse>(getSetOrgSecurityUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(orgSecurityIn)
  }
);}





export const getSetOrgSecurityMutationKey = () => ['setOrgSecurity'] as const;

export const getSetOrgSecurityMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOrgSecurity>>, TError,SetOrgSecurityMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setOrgSecurity>>, TError,SetOrgSecurityMutationVariables, TContext> => {

const mutationKey = getSetOrgSecurityMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setOrgSecurity>>, SetOrgSecurityMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setOrgSecurity(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetOrgSecurityMutationResult = NonNullable<Awaited<ReturnType<typeof setOrgSecurity>>>
    export type SetOrgSecurityMutationBody = OrgSecurityIn
    export type SetOrgSecurityMutationError = HTTPValidationError
    export type SetOrgSecurityMutationVariables = {data: OrgSecurityIn}

    /**
 * @summary Set Org Security
 */
export const useSetOrgSecurity = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOrgSecurity>>, TError,SetOrgSecurityMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setOrgSecurity>>,
        TError,
        SetOrgSecurityMutationVariables,
        TContext
      > => {
      return useMutation(getSetOrgSecurityMutationOptions(options), queryClient);
    }
    export type getOrgLogoResponse200 = {
  data: void
  status: 200
}

export type getOrgLogoResponseSuccess = (getOrgLogoResponse200) & {
  headers: Headers;
};
;

export type getOrgLogoResponse = (getOrgLogoResponseSuccess)

export const getGetOrgLogoUrl = () => {




  return `/api/orgs/current/logo`
}

/**
 * @summary Get Org Logo
 */
export const getOrgLogo = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getOrgLogoResponse> => {

  return apiFetch<getOrgLogoResponse>(getGetOrgLogoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrgLogoQueryKey = () => {
    return [
    `/api/orgs/current/logo`
    ] as const;
    }


export const getGetOrgLogoQueryOptions = <TData = Awaited<ReturnType<typeof getOrgLogo>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgLogo>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgLogoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgLogo>>> = ({ signal }) => getOrgLogo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgLogo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrgLogoQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgLogo>>>
export type GetOrgLogoQueryError = unknown


export function useGetOrgLogo<TData = Awaited<ReturnType<typeof getOrgLogo>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgLogo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgLogo>>,
          TError,
          Awaited<ReturnType<typeof getOrgLogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgLogo<TData = Awaited<ReturnType<typeof getOrgLogo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgLogo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgLogo>>,
          TError,
          Awaited<ReturnType<typeof getOrgLogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgLogo<TData = Awaited<ReturnType<typeof getOrgLogo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgLogo>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Org Logo
 */

export function useGetOrgLogo<TData = Awaited<ReturnType<typeof getOrgLogo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgLogo>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrgLogoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type uploadOrgLogoResponse200 = {
  data: OrgLogoOut
  status: 200
}

export type uploadOrgLogoResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type uploadOrgLogoResponseSuccess = (uploadOrgLogoResponse200) & {
  headers: Headers;
};
export type uploadOrgLogoResponseError = (uploadOrgLogoResponse422) & {
  headers: Headers;
};

export type uploadOrgLogoResponse = (uploadOrgLogoResponseSuccess | uploadOrgLogoResponseError)

export const getUploadOrgLogoUrl = () => {




  return `/api/orgs/current/logo`
}

/**
 * @summary Upload Org Logo
 */
export const uploadOrgLogo = async (bodyUploadOrgLogo: BodyUploadOrgLogo, options?: Parameters<typeof apiFetch>[1]): Promise<uploadOrgLogoResponse> => {
    const formData = new FormData();
formData.append(`file`, bodyUploadOrgLogo.file);

  return apiFetch<uploadOrgLogoResponse>(getUploadOrgLogoUrl(),
  {
    ...options,
    method: 'PUT'
    ,
    body: formData
  }
);}





export const getUploadOrgLogoMutationKey = () => ['uploadOrgLogo'] as const;

export const getUploadOrgLogoMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadOrgLogo>>, TError,UploadOrgLogoMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadOrgLogo>>, TError,UploadOrgLogoMutationVariables, TContext> => {

const mutationKey = getUploadOrgLogoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadOrgLogo>>, UploadOrgLogoMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  uploadOrgLogo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadOrgLogoMutationResult = NonNullable<Awaited<ReturnType<typeof uploadOrgLogo>>>
    export type UploadOrgLogoMutationBody = BodyUploadOrgLogo
    export type UploadOrgLogoMutationError = HTTPValidationError
    export type UploadOrgLogoMutationVariables = {data: BodyUploadOrgLogo}

    /**
 * @summary Upload Org Logo
 */
export const useUploadOrgLogo = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadOrgLogo>>, TError,UploadOrgLogoMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadOrgLogo>>,
        TError,
        UploadOrgLogoMutationVariables,
        TContext
      > => {
      return useMutation(getUploadOrgLogoMutationOptions(options), queryClient);
    }
    export type removeOrgLogoResponse204 = {
  data: void
  status: 204
}

export type removeOrgLogoResponseSuccess = (removeOrgLogoResponse204) & {
  headers: Headers;
};
;

export type removeOrgLogoResponse = (removeOrgLogoResponseSuccess)

export const getRemoveOrgLogoUrl = () => {




  return `/api/orgs/current/logo`
}

/**
 * @summary Remove Org Logo
 */
export const removeOrgLogo = async ( options?: Parameters<typeof apiFetch>[1]): Promise<removeOrgLogoResponse> => {

  return apiFetch<removeOrgLogoResponse>(getRemoveOrgLogoUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveOrgLogoMutationKey = () => ['removeOrgLogo'] as const;

export const getRemoveOrgLogoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOrgLogo>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeOrgLogo>>, TError,void, TContext> => {

const mutationKey = getRemoveOrgLogoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeOrgLogo>>, void> = () => {


          return  removeOrgLogo(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveOrgLogoMutationResult = NonNullable<Awaited<ReturnType<typeof removeOrgLogo>>>

    export type RemoveOrgLogoMutationError = unknown


    /**
 * @summary Remove Org Logo
 */
export const useRemoveOrgLogo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOrgLogo>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeOrgLogo>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRemoveOrgLogoMutationOptions(options), queryClient);
    }
    export type getBrandingResponse200 = {
  data: OrgBrandingOut
  status: 200
}

export type getBrandingResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getBrandingResponseSuccess = (getBrandingResponse200) & {
  headers: Headers;
};
export type getBrandingResponseError = (getBrandingResponse422) & {
  headers: Headers;
};

export type getBrandingResponse = (getBrandingResponseSuccess | getBrandingResponseError)

export const getGetBrandingUrl = (slug: string,) => {




  return `/api/orgs/branding/${slug}`
}

/**
 * @summary Get Branding
 */
export const getBranding = async (slug: string, options?: Parameters<typeof apiFetch>[1]): Promise<getBrandingResponse> => {

  return apiFetch<getBrandingResponse>(getGetBrandingUrl(slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBrandingQueryKey = (slug: string,) => {
    return [
    `/api/orgs/branding/${slug}`
    ] as const;
    }


export const getGetBrandingQueryOptions = <TData = Awaited<ReturnType<typeof getBranding>>, TError = HTTPValidationError>(slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBranding>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrandingQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBranding>>> = ({ signal }) => getBranding(slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBranding>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrandingQueryResult = NonNullable<Awaited<ReturnType<typeof getBranding>>>
export type GetBrandingQueryError = HTTPValidationError


export function useGetBranding<TData = Awaited<ReturnType<typeof getBranding>>, TError = HTTPValidationError>(
 slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBranding>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBranding>>,
          TError,
          Awaited<ReturnType<typeof getBranding>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBranding<TData = Awaited<ReturnType<typeof getBranding>>, TError = HTTPValidationError>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBranding>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBranding>>,
          TError,
          Awaited<ReturnType<typeof getBranding>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBranding<TData = Awaited<ReturnType<typeof getBranding>>, TError = HTTPValidationError>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBranding>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Branding
 */

export function useGetBranding<TData = Awaited<ReturnType<typeof getBranding>>, TError = HTTPValidationError>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBranding>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrandingQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






